var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","z-index":"1000","margin-top":"5px","box-shadow":"0px 0px 6px 0px rgba(0, 0, 0, 0.25)","background":"#fff"},attrs:{"id":"TCaptcha"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74dcc91e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/global/verifyWrap.vue
// module id = bPoQ
// module chunks = 16 17 18 19